
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { CourierMstApi } from '../../api/master/courier-mst.api';
import { CourierMst, CourierMstData } from '../../interface/master/courier-mst';

@Injectable()
export class CourierMstService extends CourierMstData {

  constructor(private api: CourierMstApi) {
    super();
  }
  list(url: string): Observable<CourierMst[]> {
    return this.api.list(url);
  }
  getById(url:string): Observable<CourierMst>{
      return this.api.getById(url);
  }
  create(url: string, data:CourierMst): Observable<CourierMst> {
    return this.api.add(url,data);
  }
  update(url: string, data:CourierMst): Observable<CourierMst> {
    return this.api.update(url,data);
  }
  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
